<template>
    <div class="holder" :class="{'disabled': disabled}" @click="holderClickHandler" @keydown="keyboardDownEventHandler" @keyup="keyboardDownEventHandler" tabindex="0">
        <i v-if="waitingForInput">Druk de toetscombinatie in die je wilt instellen.</i>
        <template v-else-if="shortcut">
            <div class="key" v-if="shortcut.ctrlKey">Ctrl</div>
            <div class="key" v-if="shortcut.shiftKey">Shift</div>
            <div class="key" v-if="shortcut.altKey">Alt</div>
            <div class="key" v-if="shortcut.metaKey">⌘</div>
            <div class="key">{{ shortcut.key.toLocaleUpperCase('nl-NL') }}</div>
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {KeyControlSetting} from '@/components/deploymentAutocomplete/types';
    import {ShortcutType} from '@/types/enums/ShortcutType';

    @Component({
        emits: ['change:shortcut', 'toggle:waitingForInput'],
    })
    export default class ShortcutModalInput extends Vue {
        @Prop() public shortcut?: KeyControlSetting;
        @Prop({required: true}) public type!: ShortcutType;
        @Prop({type: Boolean}) public disabled!: boolean;

        private static readonly MAIN_KEY_REGEX: RegExp = /^(?:[abd-uwy0-9[\]{};:'",.<>/?!@#$%^&*()\-=_+]|F\d+)$/mi;

        public waitingForInput: boolean = false;

        public keyboardDownEventHandler(e: KeyboardEvent): void {
            if (this.waitingForInput) {
                if (ShortcutModalInput.MAIN_KEY_REGEX.test(e.key)) {
                    e.preventDefault();
                    this.waitingForInput = false;

                    const configuredShortcut: KeyControlSetting = {
                        key: e.key,
                        ctrlKey: e.ctrlKey,
                        altKey: e.altKey,
                        shiftKey: e.shiftKey,
                        metaKey: e.metaKey,
                    };

                    this.$emit('toggle:waitingForInput', false);
                    this.$emit('change:shortcut', configuredShortcut, this.type);
                }
            } else if (e.key === 'Enter') {
                this.holderClickHandler();
            }
        }

        public holderClickHandler(): void {
            if (this.disabled) {
                return;
            }
            this.waitingForInput = true;
            this.$emit('toggle:waitingForInput', true);
        }
    }
</script>

<style lang="scss" scoped>
    .holder {
        display: inline-block;
        background: var(--theme-light);
        width: 100%;
        padding: 0.375rem;
        border: 1px solid var(--cq-medium-grey);
        border-radius: 3px;

        &.disabled {
            border-color: var(--cq-dark-grey);
            background: var(--cq-lighter-grey);

            .key {
                background: #ccc;
            }
        }

        .key {
            display: inline-block;
            background: #aaa;
            border: 1px solid #888;
            border-radius: 0.125rem;
            padding: 0.0625rem 0.375rem;
            color: #000;

            + .key {
                margin-left: 0.1875rem;
            }
        }
    }
</style>
